import api from './api';

/**
 * @typedef {
    | 'draft'
    | 'queued_for_pregrading'
    | 'pregrading'
    | 'queued_for_live'
    | 'live'
    | 'withdrawn'
    | 'archived'
 * } TestStatus
 */

/**
 * @param {string} testId
 * @param {string} levelId
 * @param {TestStatus} status
 * @returns {Promise<{
 *  test_group_id: string
 *  name: string
 *  status: TestStatus
 *  level_id: string
    }>}
 */
export default async function updateTestStatus(testId, levelId, status) {
    const { data } = await api.put(
        `/levels/${levelId}/test_groups/${testId}/status`,
        { status }
    );

    return data;
}